import {
  IRawWalletTransactionsRes,
  IWalletTransactionItem,
  TWalletTransactionStatus,
  TWalletTransactionType,
} from "@/interfaces";
import { extractTime, toJalali } from "@/lib";

type typeValues = {
  [K in TWalletTransactionType]: string;
};
type statusValues = {
  [K in TWalletTransactionStatus]: string;
};

export const typeMap: typeValues = {
  purchase: "خرید استعلام",
  withdraw: "توسط مدیر",
  deposit: "شارژ کیف پول",
} as const;

export const statusMap: statusValues = {
  success: "موفق",
  pending: "ناموفق",
} as const;

export const getWalletTransactionsAdapter = (
  data: IRawWalletTransactionsRes,
): IWalletTransactionItem[] => {
  return data.map(
    ({ id, created_at, amount, description, type, status, track_id }) => {
      const cleanAmount = amount
        .toString()
        .replace(/-/g, "")
        .replace(".00", "");

      return {
        id: id.toString(),
        date: toJalali(created_at),
        time: extractTime(created_at),
        amount: cleanAmount,
        track_id,
        description,
        status: statusMap[status],
      };
    },
  );
};
